import React, { useState } from 'react';
import styles from './Filter.module.css';

const Filter = () => {
  const [filters, setFilters] = useState({
    salary: '',
    experience: '',
    workMode: [],
    company: [],
  });

  const salaryOptions = ['$10k - $50k', '$50k - $100k', '$100k - $150k'];
  const experienceOptions = ['0-2 years', '3-5 years', '6-10 years', '10+ years'];
  const workModeOptions = ['Remote', 'Hybrid', 'On-site'];
  const companyOptions = ['Company A', 'Company B', 'Company C', 'Company D'];

  const handleFilterChange = (category, value, isCheckbox) => {
    if (isCheckbox) {
      
      setFilters((prevState) => {
        const updatedValues = prevState[category];
        if (updatedValues.includes(value)) {
          return {
            ...prevState,
            [category]: updatedValues.filter((item) => item !== value),
          };
        } else {
          return {
            ...prevState,
            [category]: [...updatedValues, value],
          };
        }
      });
    } else {
      
      setFilters((prevState) => ({
        ...prevState,
        [category]: value,
      }));
    }
  };

  return (
    <div className={styles.filterContainer}>
     
      <div className={styles.filterSelect}>
        <p>Salary:</p>
        {salaryOptions.map((option) => (
          <div key={option} className={styles.radioWrapper}>
            <input
              type="radio"
              id={option}
              name="salary"
              value={option}
              checked={filters.salary === option}
              onChange={() => handleFilterChange('salary', option, false)}
            />
            <label htmlFor={option}>{option}</label>
          </div>
        ))}
      </div>

     
      <div className={styles.filterSelect}>
        <p>Experience:</p>
        {experienceOptions.map((option) => (
          <div key={option} className={styles.radioWrapper}>
            <input
              type="radio"
              id={option}
              name="experience"
              value={option}
              checked={filters.experience === option}
              onChange={() => handleFilterChange('experience', option, false)}
            />
            <label htmlFor={option}>{option}</label>
          </div>
        ))}
      </div>

      
      <div className={styles.filterSelect}>
        <p>Work Mode:</p>
        {workModeOptions.map((option) => (
          <div key={option} className={styles.checkboxWrapper}>
            <input
              type="checkbox"
              id={option}
              checked={filters.workMode.includes(option)}
              onChange={() => handleFilterChange('workMode', option, true)}
            />
            <label htmlFor={option}>{option}</label>
          </div>
        ))}
      </div>

      
      <div className={styles.filterSelect}>
        <p>Company:</p>
        {companyOptions.map((option) => (
          <div key={option} className={styles.checkboxWrapper}>
            <input
              type="checkbox"
              id={option}
              checked={filters.company.includes(option)}
              onChange={() => handleFilterChange('company', option, true)}
            />
            <label htmlFor={option}>{option}</label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Filter;
